<template>
  <div class="app" v-if="$store.getters.getLaboratoryContext">
    <AppHeader fixed>
      <SidebarToggler class="d-lg-none" display="md" mobile />
      <b-link class="navbar-brand" to="/">
        <img
          class="navbar-brand-full"
          src="img/brand/logo.png"
          width="89"
          height="25"
          alt="DTE Logo"
        />
        <img
          class="navbar-brand-minimized"
          src="img/brand/sygnet.png"
          width="30"
          height="30"
          alt="DTE Logo"
        />
      </b-link>
      <SidebarToggler class="d-md-down-none" display="lg" />
      <b-navbar-nav class="ml-auto">
        <laboratory-context-select />
        <b-nav-item
          class="d-md-down-none"
          :to="`/staff/${$store.getters.getAuthStaffID}`"
        >
          <i class="fal fa-user" />
        </b-nav-item>

        <b-nav-item
          v-b-tooltip.hover
          :title="`${
            show_access_message ? 'Hide' : 'Show'
          } access notifications`"
          class="d-md-down-none"
          @click="toggleAccessMessages"
        >
          <i v-if="show_access_message" class="fal fa-toggle-on" />
          <i v-else class="fal fa-toggle-off" />
        </b-nav-item>
        <b-nav-item class="d-md-down-none" @click="logout" title="Logout">
          <i class="fal fa-sign-out" />
        </b-nav-item>
      </b-navbar-nav>
      <AsideToggler class="d-none d-lg-block" />
    </AppHeader>
    <div class="app-body">
      <AppSidebar fixed>
        <SidebarHeader />
        <SidebarForm />
        <SidebarNav :navItems="nav" />
        <SidebarFooter />
        <SidebarMinimizer />
      </AppSidebar>
      <main class="main">
        <b-overlay :show="overlay" class="h-100">
          <Breadcrumb :list="list" />
          <div class="container-fluid table-container">
            <router-view></router-view>
          </div>
        </b-overlay>
      </main>
      <AppAside fixed>
        <DefaultAside />
      </AppAside>
    </div>
    <TheFooter>
      <div>
        <a href="#">DTE CRM</a>
        <span class="ml-1">&copy; {{ new Date().getFullYear() }}</span>
      </div>
    </TheFooter>
  </div>
</template>

<script>
import nav from "@/_nav";
import {
  Header as AppHeader,
  SidebarToggler,
  Sidebar as AppSidebar,
  SidebarFooter,
  SidebarForm,
  SidebarHeader,
  SidebarMinimizer,
  SidebarNav,
  Aside as AppAside,
  AsideToggler,
  Footer as TheFooter /*, Breadcrumb*/,
} from "@coreui/vue";
import Breadcrumb from "@/components/shared/Breadcrumb";
import DefaultAside from "./DefaultAside";
import DefaultHeaderDropdown from "./DefaultHeaderDropdown";
import DefaultHeaderDropdownNotif from "./DefaultHeaderDropdownNotif";
import LaboratoryContextSelect from "@/components/app/LabContextSelect";
import { AUTH_LOGOUT } from "@/store/action-types";
import { mapActions, mapGetters } from "vuex";
import CreateNavAccessCheck from "@/components/shared/mixins/CreateNavAccessCheck";
import markerSDK from '@marker.io/browser'

export default {
  name: "DefaultContainer",
  components: {
    AsideToggler,
    AppHeader,
    AppSidebar,
    AppAside,
    TheFooter,
    Breadcrumb,
    DefaultAside,
    DefaultHeaderDropdown,
    DefaultHeaderDropdownNotif,
    SidebarForm,
    SidebarFooter,
    SidebarToggler,
    SidebarHeader,
    SidebarNav,
    SidebarMinimizer,
    LaboratoryContextSelect,
    markerSDK
  },
  mixins: [CreateNavAccessCheck],
  data() {
    return {
      nav: nav.items,
    };
  },
  computed: {
    ...mapGetters({
      show_access_message: "showAccessMessage",
    }),
    overlay() {
      return this.$store.getters.showOverlay;
    },
    name() {
      return this.$route.name;
    },
    list() {
      return this.$route.matched.filter(
        (route) => route.name || route.meta.label
      );
    },
  },
  methods: {
    ...mapActions(["TOGGLE_ACCESS_MESSAGE"]),
    toggleAccessMessages() {
      this.TOGGLE_ACCESS_MESSAGE();
    },
    logout() {
      this.$store.dispatch(AUTH_LOGOUT, {}).then(() => {
        this.$router.push("/login");
      });
    },
  },
  async mounted() {
    this.setUpNavItems();

    try {
      const widget = await markerSDK.loadWidget({ project: process.env.VUE_APP_MARKER_PROJECT_ID })
    } catch (error) {
      console.error('Error loading Marker widget', error);
    }
  }
};
</script>

<style>
.table-container {
  overflow: scroll;
  scrollbar-width: none;
}
.container-fluid {
  min-height: 88%;
}
</style>
